module.exports = function (app) {
    app.controller('pages.account.contact-preferences', ['$scope', 'brand', 'sessionData', '$q', 'services', 'UMSParse', 'aemContent', 'coremetrics', 'modal',
        function ($scope, brand, sessionData, $q, services, UMSParse, aemContent, coremetrics, modal) {
            // dojo polyfills
            var lang = {mixin: angular.extend, clone: angular.copy, hitch: function(s, f) { return f.bind(s); }, replace: function(i,o) { var z = i.match(/\{.*?\}/g) || []; return z.reduce(function(a,c) { return a.replace(c,o[c.substring(1,c.length-1)]); }, i); }}
            var dojoArray = {forEach: function(a, f) { return a.forEach(f); }, indexOf: function(a, s) { return a.indexOf(s); }}
            var djArray = dojoArray;
            var all = $q.all;
            // "bootstrap/utilities/Modal",
            // "bootstrap/services/services",
            // "dojo/io-query",
            // "bootstrap/utilities/Article",
            // "app/articles/FormForPostRequest"
            var btsGlobal = {config: {brand: brand.current, portalGroupNumber: sessionData.groupNumber}, appConfig: sessionData.appConfig};

	        var that = {};
	        var translate = function(model, abbr) {
	            /*
	            *  This function will take in the abbreviation for the preference, and return the appropriate full length string
	            *  @param {string} abbr - Abbreviation for contract preference selection
	            */
	            if (abbr === "IE" && model.data.emailAddress) {
	                return "Personal Email";
	            }
	            else if (abbr === "UM") {
	                return "U.S. Mail";
	            }
	            else if (abbr === "CE" && model.data.workEmailAddress) {
	                return "Work Email";
	            }
	            else if (abbr === "HP" && model.data.homePhone) {
	                return "Home Phone";
	            }
	            else if (abbr === "WP" && model.data.workPhone) {
	                return "Work Phone";
	            }
	            else if (abbr === "MP" && model.data.mobilePhone) {
	                return "Mobile Phone";
	            }
	            else if (abbr === "MT" && model.data.mobilePhone) {
	                return "Text Message";
	            }
	            else if (abbr === "NN") {
	                return "Do Not Contact";
	            }
	            else if (abbr === "UE") {
	                return "Old Email";
	            }
	            else {
	                return "Select";
	            }
	        };
	        var reverseTranslate = function(text) {
	            switch (text) {
	                case "Personal Email":
	                    return "IE"
	                    break;
	                case "U.S. Mail":
	                    return "UM"
	                    break;
	                case "Work Email":
	                    return "CE"
	                    break;
	                case "Home Phone":
	                    return "HP"
	                    break;
	                case "Work Phone":
	                    return "WP"
	                    break;
	                case "Mobile Phone":
	                    return "MP"
	                    break;
	                case "Text Message":
	                    return "MT"
	                    break;
	                case "Do Not Contact":
	                    return "NN"
	                    break;
	                case "Old Email":
	                    return "UE"
	                    break;
	                default:
	                    return ""
	                    break;
	            }
	        };
	        var isPaperless = function(model) {
	            var sections = model.sections;
	            for (var section in sections) {
	                for (var topic in sections[section].topics) {
	                    if ((topic === "healthCoach") || (topic === "savingsAdvisor" && model.data.emailConfirmedInd && model.data.emailConfirmedInd.toLowerCase() !== 'confirmed')) {
	                        continue;
	                    }
	                    else if (sections[section].topics[topic].canView && sections[section].topics[topic].selected !== "Personal Email") {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        };
	        var errorCheck = function(model, type) {
	           // debugger ;
	            var error = {
	                heading: "Contact Preference Selection Error",  // Default heading for modal
	                msg: "Unknown Error",        // Default error message
	                show: false
	            };
	            switch (type) {
	                case "Work Phone":
	                    if (model.data.workPhone === "") {
	                            error.heading = "Unconfirmed Work Phone";
	                            error.msg = "You do not have work phone on file. Please choose a different option.";
	                            error.show = true;
	                    }
	                    break;
	                case "Home Phone":
	                    if (model.data.homePhone === "") {
	                            error.heading = "Unconfirmed Home Phone";
	                            error.msg = "You do not have a home phone on file. Please choose a different option.";
	                            error.show = true;
	                    }
	                    break;
	                case "Mobile Phone":
	                case "Text Message":
	                    if (model.data.mobilePhone === "") {
	                            error.heading = "Unconfirmed Mobile Phone";
	                            error.msg = "You do not have a mobile phone on file. Please choose a different option.";
	                            error.show = true;
	                    }
	                    break;
	                // Flagged as "check to be sure we do not need this"
	                /*
	                case "Personal Email":
	                    if (model.data.emailAddress === "" /*|| model.data.emailConfirmedInd.toUpperCase() == "NOT CONFIRMED") {
	                            //error.heading = "";
	                            error.msg = "Unconfirmed Personal Email: NEED ERROR MESSAGE (Content TBD)";
	                            error.show = true;
	                    }
	                    break;
	                */
	                case "Work Email":
	                    if (model.data.workEmailAddress === "") {
	                            //error.heading = "";
	                            error.msg = "You do not have a work email on file. Please choose a different option.";
	                            error.show = true;
	                    }
	                    break;
	            }
	            return error;
	        };
	        var restoreCache = function(model, cacheType) {
	            for (var section in model.sections) {
	                for (var topic in model.sections[section].topics) {
	                    if (model.cache[cacheType][section] && model.cache[cacheType][section].topics[topic].value) {
	                        // model.sections[section].topics[topic].selected.value = model.cache[cacheType][section].topics[topic].value;
	                        // model.sections[section].topics[topic].selected.label = model.cache[cacheType][section].topics[topic].value;
	                        model.sections[section].topics[topic].selected = model.cache[cacheType][section].topics[topic].value;
	                    }
	                }
	            }
	            model.data.marketingAuthorizationAccepted = model.cache[cacheType].marketingAuthorizationAccepted;
	        };
	        var storeCache = function(model, cacheType) {
	            var sections = {}
	            for (var section in model.sections) {
	                sections[section] = {topics: {}};
	                for (var topic in model.sections[section].topics) {
	                    sections[section].topics[topic] = {
	                        // "title" : model.sections[section].topics[topic].text.serviceName,
	                        "value" : model.sections[section].topics[topic].selected,
	                        "canView" : model.sections[section].topics[topic].canView
	                    }
	                }
	            }
	            model.cache[cacheType] = sections;
	            model.cache[cacheType].marketingAuthorizationAccepted = model.data.marketingAuthorizationAccepted;
	        };
	        var changesExist = function(model) {
	            var serverPostData = {}
	            var hasChanges = false;
	            for (var section in model.sections) {
	                for (var topic in model.sections[section].topics) {
	                    if (model.sections[section].topics[topic].canView) {
	                        if (model.sections[section].topics[topic].selected !== model.cache.serverCache[section].topics[topic].value) {
	                            serverPostData[model.sections[section].topics[topic].text.serviceName] = reverseTranslate(model.sections[section].topics[topic].selected);
	                            hasChanges = true;
	                        }
	                    }
	                }
	            }
	            if (model.data.marketingAuthorizationAccepted !== model.cache.serverCache.marketingAuthorizationAccepted) {
	                serverPostData.marketingAuthorizationAccepted = model.data.marketingAuthorizationAccepted;
	                hasChanges = true;
	            }

	            if(model.isSDCEligiblity){
	                if ( model.isOptIn !== null && model.isOptIn !== undefined && $('#goSecureText')[0].checked !== model.isOptIn ) {
	                    hasChanges = true;
	                }
	            }

	            if (hasChanges) {
	                return serverPostData;
	            }
	            return false;
	        };


            var toMerge = {
	            model:{
	            	saveArticle: {
						showingAcceptTerms: false,
						showingRevokeTerms: false,
			            isND: (brand === 'ndbcbs' ?  true : false),
						content: {
							"header": {
								"sectionTitle": "SAVE YOUR CHANGES"
							},
							"body": {
								"open": false,
								"subHdr":"<strong>Review Legal documents:</strong>",
								"input1Label":"Contact Preferences Terms and Conditions",
								"input1Checked": false,
								"input2Label":"Other Products & Services Authorization",
								"input2Checked": false,
								"showPartnerAuth" : true,
								"showInput2CheckBox" : false,
								"showInput1CheckBox" : false,
								"alert":"Please note, your employer may require us to send you information through US Mail or your work email address.",
								"p1":"We will use your preferences whenever we can. However, there may be times when we will have to send information another way.",
								"contentRevokeTerms": "You have chosen to REVOKE the terms and conditions of the Other Products and Services Authorization.  By doing so, you are no longer authorizing your health plan and its affiliates and subsidiaries to use your Protected Health Information as described in the authorization.",
								"contentAcceptTerms": "You have chosen to ACCEPT the terms and conditions of the Other Products and Services Authorization.  By doing so, you are authorizing your health plan and its affiliates and subsidiaries to use your Protected Health Information as described in the authorization.",
								"contentTerms": "",
								"read": "View Document",
								"actions":{
									"save":"Save",
									"cancel":"Cancel"
								},
								"expandNotebookTablet": true,
								"mobileSaveOpen": false,
								"canSeeSaveTab": false,
								"saveConfirmationText": "Changes Saved!",
								"saveConfirmed": true,
								"arrowsUp": false
							}
						}
	            	},

	                bAlertsDrawerOpen: 'close',
	                bHWDrawerOpen: 'close',
	                bAddSvcDrawerOpen: 'close',
	                alertsDrawerClicked: function(){
	                    this.bAlertsDrawerOpen = (this.bAlertsDrawerOpen == 'close' ? 'open' : 'close') ;
	                },
	                isAlertsExpanded: function() {
	                    return this.bAlertsDrawerOpen == 'close' ;
	                },
	                HWDrawerClicked: function(){
	                    this.bHWDrawerOpen = (this.bHWDrawerOpen == 'close' ? 'open' : 'close') ;
	                },
	                isHWExpanded: function() {
	                    return this.bHWDrawerOpen == 'close' ;
	                },
	                AddSvcClicked: function(){
	                    this.bAddSvcDrawerOpen = (this.bAddSvcDrawerOpen == 'close' ? 'open' : 'close') ;
	                },
	                isAddSvcExpanded: function() {
	                    return this.bAddSvcDrawerOpen == 'close' ;
	                },
	                setPaperlessBox: function(firstLoad) {
	                    if (isPaperless(this)) {
	                        this.headers.checked = true;
	                    }
	                    else {
	                        this.headers.checked = false;
	                    }
	                    if(firstLoad && btsGlobal.config.brand.sharedBrandCode.toLowerCase() === 'wybcbs'){
	                        this.headers.checked = true;
	                        var that = this;
	                        setTimeout(function() {
	                                that.wybcbsTogglePaperless();
	                        }, 1000);
	                    }
	                },
	                togglePaperless: function() {
	                    var that = this;

	                    if(that.goPaperCoreMetrics != undefined && that.goPaperCoreMetrics != true)
	                    {
	                        coremetrics.elementTag('Go Paperless','MEMBER:ACCOUNT SETTINGS');
	                        that.goPaperCoreMetrics = true;
	                    }
	                    if (event.target.checked) {
	                        storeCache(this, "paperlessCache");
	                        for (var section in this.sections) {
	                            for (var topic in this.sections[section].topics) {
	                                if ((topic === "healthCoach") || (topic === "savingsAdvisor" && this.data.emailConfirmedInd && this.data.emailConfirmedInd.toLowerCase() !== 'confirmed')) {
	                                    continue;
	                                }
	                                else if (this.sections[section].topics[topic].canView) {
	                                    this.sections[section].topics[topic].selected = "Personal Email";
	                                }
	                            }
	                        }
	                        this.saveArticle.content.body.showInput2CheckBox = true;
	                        this.saveArticle.content.body.showInput1CheckBox = true;
	                    } else {
	                            this.saveArticle.content.body.showInput2CheckBox = false;
	                            this.saveArticle.content.body.showInput1CheckBox = false;
	                            restoreCache(this, "paperlessCache");
	                    }
	                    this.showHideThirdPartyAuth();
	                    this.showSaveBody();
	                    this.specialAlert();
	                },
	                wybcbsTogglePaperless: function() {
	                    var that = this;

	                    if(that.goPaperCoreMetrics != undefined && that.goPaperCoreMetrics != true)
	                    {
	                        coremetrics.elementTag('Go Paperless','MEMBER:ACCOUNT SETTINGS');
	                        that.goPaperCoreMetrics = true;
	                    }
	                    if (true) {
	                        storeCache(this, "paperlessCache");
	                        for (var section in this.sections) {
	                            for (var topic in this.sections[section].topics) {
	                                if ((topic === "healthCoach") || (topic === "savingsAdvisor" && this.data.emailConfirmedInd && this.data.emailConfirmedInd.toLowerCase() !== 'confirmed')) {
	                                    continue;
	                                }
	                                else if (this.sections[section].topics[topic].canView) {
	                                    this.sections[section].topics[topic].selected = "Personal Email";
	                                }
	                            }
	                        }
	                        this.saveArticle.content.body.showInput2CheckBox = true;
	                        this.saveArticle.content.body.showInput1CheckBox = true;
	                    } else {
	                        this.saveArticle.content.body.showInput2CheckBox = false;
	                        this.saveArticle.content.body.showInput1CheckBox = false;
	                        restoreCache(this, "paperlessCache");
	                    }
	                    this.showHideThirdPartyAuth();
	                    this.showSaveBody();
	                    this.specialAlert();
	                },
	                toggleSecureMessage: function(){
	                    var that = this;
	                    // chk for mobile number
	                    this.hasMobileNumber = (this.data.mobilePhone != '') ;
	                    this.bIsMobileNoVisible = ( (event.target.checked) && (! this.hasMobileNumber) ) ;

	                    if(that.goPaperCoreMetrics != true){
	                        coremetrics.elementTag('Go Paperless','MEMBER:ACCOUNT SETTINGS');
	                        that.goPaperCoreMetrics = true;
	                    }
	                    this.isTextMeChanged = (event.target.checked)? true : false;

	                    if ( (event.target.checked) && (this.bIsMobileNoVisible) && (this.headers.sdcMobilePhone.value.trim() == '') ){
	                        this.saveArticle.content.body.showInput2CheckBox = true;
	                        this.saveArticle.content.body.showInput1CheckBox = true;
	                        this.saveArticle.content.body.subHdr = "I have <strong>read</strong> and I <strong>accept</strong>:";
	                        this.model.saveArticle.showSaveBody(false);
	                    } else {
	                        this.showSaveBody();
	                    }


	                },

	                specialAlert: function() {
	                    // HealthCoach doesn't have personal email as an option.  If nothing has been selected, display a msg
	                    if (this.sections.healthWellness.topics.healthCoach.selected.toUpperCase() === "SELECT" && isPaperless(this)) {
	                        this.sections.healthWellness.topics.healthCoach.hasSpecialContent = true;
	                        this.sections.healthWellness.topics.healthCoach.specialContentClass = 'validation-error';
	                        this.headers.greenAlert = true;
	                    }
	                    else {
	                        this.sections.healthWellness.topics.healthCoach.hasSpecialContent = false;
	                        this.sections.healthWellness.topics.healthCoach.specialContentClass = '';
	                        this.headers.greenAlert = false;
	                    }
	                    // Savings Advisor doesn't have personal email as an option if it's not confirmed.  If nothing has been selected AND personal email is not an option, display a msg
	                    if (this.data.emailConfirmedInd && this.data.emailConfirmedInd.toLowerCase() !== 'confirmed' && this.sections.additionalServices.topics.savingsAdvisor.selected.toUpperCase() === "SELECT" && isPaperless(this)) {
	                        this.sections.additionalServices.topics.savingsAdvisor.hasSpecialContent = true;
	                        this.sections.additionalServices.topics.savingsAdvisor.specialContentClass = 'validation-error';
	                        this.headers.greenAlert = true;
	                    }
	                    else {
	                        this.sections.additionalServices.topics.savingsAdvisor.hasSpecialContent = false;
	                        this.sections.additionalServices.topics.savingsAdvisor.specialContentClass = '';
	                        this.headers.greenAlert = false;
	                    }
	                },
	                marketingAuthorizationAcceptedChanged: function(value) {
	                    this.data.marketingAuthorizationAccepted = value;
	                    this.showSaveBody();
	                },
	                validateMobilePhone: function() {
	                    var strPhoneNum = this.headers.sdcMobilePhone.value.replace(/[^\d]/g, '');
	                    if (strPhoneNum.length === 10) {
	                        this.model.saveArticle.showSaveBody(true);
	                        this.isTextMeChanged = true;
	                    }
	                    else {
	                        this.model.saveArticle.showSaveBody(false);
	                    }
	                },
	                selectionEvent: function(selectedValue) {
	                   // debugger;
	                    // var evt = event;
	                    var evt = event;
	                    var eventSrc = evt.srcElement || evt.target;
	                    var tmpId = eventSrc.id;
	                    this.selectionCoremetrics(tmpId);
	                    var error = errorCheck(this, selectedValue);
	                    if (!error.show) {
	                        storeCache(this, "prefsCache");
	                        this.showSaveBody();
	                    }
	                    else {
	                        restoreCache(this, "prefsCache");
	                        this.errorModal(error);
	                    }
	                    if (this.headers.alreadyGreen && !isPaperless(this)) {
	                        this.headers.alreadyGreen = false;
	                    }
	                    this.showHideThirdPartyAuth();
	                    this.showHideInputCheckBox();
	                    this.specialAlert();
	                    this.setPaperlessBox();
	                },
	                selectionCoremetrics: function (selectId)
	                {
	                    var that = this;
	                    switch(selectId)
	                    {
	                        case 'invoicesSelect':
	                            if(that.invoiceCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Invoices','MEMBER:ACCOUNT SETTINGS');
	                                that.invoiceCoremetrics = true;
	                            }
	                            break;
	                        case 'eobSelect':
	                            if(that.eobCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Explanation of Benefits & Claims','MEMBER:ACCOUNT SETTINGS');
	                                that.eobCoremetrics = true;
	                            }
	                            break;
	                        case 'noticesSelect':
	                            if(that.noticesCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Insurance Plan Notices','MEMBER:ACCOUNT SETTINGS');
	                                that.noticesCoremetrics = true;
	                            }
	                            break;
	                        case 'statementSelect':
	                            if(that.statementCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Health Statements','MEMBER:ACCOUNT SETTINGS');
	                                that.statementCoremetrics = true;
	                            }
	                            break;
	                        case 'wellnessSelect':
	                            if(that.wellnessCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Wellness, Savings & More','MEMBER:ACCOUNT SETTINGS');
	                                that.wellnessCoremetrics = true;
	                            }
	                            break;
	                        case 'newsletterSelect':
	                            if(that.newsletterCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Member Newsletter','MEMBER:ACCOUNT SETTINGS');
	                                that.newsletterCoremetrics = true;
	                            }
	                            break;
	                        case 'coachSelect':
	                            if(that.coachCoremtrics != true)
	                            {
	                                coremetrics.elementTag('Health Coach','MEMBER:ACCOUNT SETTINGS');
	                                that.coachCoremtrics = true;
	                            }
	                            break;
	                        case 'savingsAdvisorSelect':
	                            if(that.savingsAdvisorCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Savings Advisor','MEMBER:ACCOUNT SETTINGS');
	                                that.savingsAdvisorCoremetrics = true;
	                            }
	                            break;
	                        case 'passportReminderSelect':
	                            if(that.passportReminderCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Passport Rewards','MEMBER:ACCOUNT SETTINGS');
	                                that.passportReminderCoremetrics = true;
	                            }
	                            break;
	                        case 'otherSelect':
	                            if(that.otherCoremetrics != true)
	                            {
	                                coremetrics.elementTag('Other Products & Services','MEMBER:ACCOUNT SETTINGS');
	                                that.otherCoremetrics = true;
	                            }
	                            break;
	                    }
	                },
	                showHideInputCheckBox: function() {
	                    if (this.sections.additionalServices.topics.partnerProducts.canView &&
	                        this.sections.additionalServices.topics.partnerProducts.selected.value == "Do Not Contact") {
	                        this.saveArticle.showingAcceptTerms = false;
	                        this.saveArticle.showingRevokeTerms = false;
	                    } else {
	                        if (this.saveArticle.content.body.input2Checked.value) {
	                            this.saveArticle.content.body.input2Checked.value = false;
	                        }
	                    }
	                },
	                showHideThirdPartyAuth: function() {
	                    switch (btsGlobal.config.brand.sharedBrandCode) {
	                        case 'hmbcbs':
	                        case 'hbs':
	                        case 'hmbcbsde':
	                        case 'ibccr':
	                        case 'ibcah':
	                        case 'mincr':
	                        case 'wybcbs':
	                            // showPartnerAuth only applies to wpa,cpa,de,ibc core, and ibc ah
	                            if (this.sections.additionalServices.topics.partnerProducts.canView && this.sections.additionalServices.topics.partnerProducts.selected.value == "Do Not Contact") {
	                                this.saveArticle.content.body.showPartnerAuth = false;
	                            }
	                            else {
	                                this.saveArticle.content.body.showPartnerAuth = true;
	                            }
	                            break;
	                        default:
	                            this.saveArticle.content.body.showPartnerAuth = false;
	                            break;
	                    }
	                },
	                showSaveBody: function() {
	                    if (changesExist(this) || (this.isTextMeChanged !== undefined && this.isTextMeChanged === true)) {
	                        this.saveArticle.content.body.showInput2CheckBox = true;
	                        this.saveArticle.content.body.showInput1CheckBox = true;
	                        this.saveArticle.content.body.subHdr = "I have <strong>read</strong> and I <strong>accept</strong>:";
							this.saveArticle.content.saveConfirmed = false;
							this.saveArticle.content.showButtons = true;
	                        window.onbeforeunload= function(event) {
	                            event.returnText = "You have unsaved changes."
	                            return event;
	                        }
	                    }
	                    else {
	                        this.saveArticle.content.body.showInput2CheckBox = false;
	                        this.saveArticle.content.body.showInput1CheckBox = false;
	                        this.saveArticle.content.body.subHdr = "<strong>Review Legal documents:</strong>";
							this.saveArticle.content.saveConfirmed = false;
							this.saveArticle.content.showButtons = false;
	                        window.onbeforeunload = null;
	                    }

	                },
	                cancel: function() {
						this.saveArticle.content.body.input2Checked.value = this.cache.serverCache.marketingAuthorizationAccepted;
						this.saveArticle.content.body.input1Checked.value = false;

	                    this.saveArticle.content.body.showInput2CheckBox = false;
	                    this.saveArticle.content.body.showInput1CheckBox = false;
	                    this.saveArticle.content.body.subHdr = "<strong>Review Legal documents:</strong>";
	                    restoreCache(this, "serverCache");
	                    this.setPaperlessBox();
	                    this.headers.alreadyGreen = isPaperless(this);
	                    this.showHideThirdPartyAuth();
	                    this.specialAlert();
	                    window.onbeforeunload = null;
	                    
						this.showSaveBody();
	                },
					input2Changed: function() {
						this.marketingAuthorizationAcceptedChanged(this.saveArticle.content.body.input2Checked.value);
	                    var evt = event;
						if(evt.target.checked){
							this.showingAcceptTerms = true;
							this.showingRevokeTerms = false;
						}
						else {
							this.showingAcceptTerms = false;
							this.showingRevokeTerms = true;
						}
					},
					showAcceptTerms: function() {
						return this.showingAcceptTerms;
					},
					showRevokeTerms: function() {
						return this.showingRevokeTerms;
					},
					saveEvent: function() {
						if (!this.saveArticle.content.body.input1Checked) {
							this.saveErrorModal();
						}
						else {
							this.saveArticle.buttonsDisabled = true;
			                //debugger;
							this.save().then(lang.hitch(this, function() {
								this.saveArticle.content.saveConfirmed = true;
								this.saveArticle.content.showButtons = false;
								this.saveArticle.content.body.input1Checked = false;
								this.saveArticle.buttonsDisabled = false;
								this.saveArticle.content.body.contentTerms = "";
							}), lang.hitch(this, function() {
								this.saveArticle.buttonsDisabled = false;
							}));
						}
					},
					saveErrorModal: function() {
                        modal.open(
                            {
                                heading: 'Terms and Conditions',
                                template: '<p class="margin-bottom">You cannot save until you have read and you accept the terms and conditions. Please check the box to let us know you have.</p><div class="text-r"><button data-ng-click="closeModal();" class="margin-top action-btn">OK</button></div>'
                                // templateUrl: 'coverage/medical-benefits.appTemplate.html/chmhom/modals/benefitBookletDisclaimer',
                                // scope: $scope
                            }
                        );
							// closeClick: function() { this.closeModal(); }
					},
	                save: function() {

	                    var prefs = changesExist(this);
	                    if (isPaperless(this)) {
	                        // caused problems, leaving false until july release.
	                        prefs.paperlessInd = false;
	                    }
	                    else {
	                        prefs.paperlessInd = false;
	                    }
	                    var tmp = lang.mixin({}, this.fullData, prefs);
	                    this.inputsDisabled = true;
	                    window.onbeforeunload = null;
	                    

	                    //debugger ;
	                    if(this.isSDCEligiblity){
	                        if( (this.headers.checkedSDC.value != null) && (this.headers.checkedSDC.value !== this.data.secureTextMessageOptInOut) ){
	                            // tmp.secureTextMessageOptInOut = this.headers.checkedSDC.value ;
	                            tmp.secureTextMessageOptInOut = this.headers.checkedSDC ;
	                        } else{
	                            delete tmp['secureTextMessageOptInOut'];
	                        }

	                        if (this.bIsMobileNoVisible){
	                            tmp.mobilePhone = $('#sdcMobileNumber').val().match(/[0-9]*/g).join('');
	                        }else {
	                            delete tmp['intakeRequest'];
	                            delete tmp['mobilePhone'];
	                        }
	                    }
	                    else{
	                        if(this.data.mobilePhone === ""){
	                            delete tmp['intakeRequest'];
	                            delete tmp['mobilePhone'];
	                        }
	                        else{
	                            tmp.mobilePhone = this.data.mobilePhone;
	                        }
	                    }

	                    tmp.brand = sessionData.memberInfo.brand;
	                        var saveData = services.rbsmbl.AccountSettingsRetrive().saveAccountSettings(tmp, 'contactPrefSave', sessionData.memberInfo.brand, sessionData.memberInfo.userName);
	                        saveData.then(lang.hitch(this, function (data2) {
	                            var postData = {profile: {}}, chcData = this.chcData;
	                            if (chcData && prefs.selectedSavingsAdvisor) {
	                                switch (prefs.selectedSavingsAdvisor) {
	                                    case "MT":
	                                        postData.profile.sms_notify_ways_to_save = true;
	                                        postData.profile.savings_reminder_email = false;
	                                        postData.profile.ways_to_save_email = false;
	                                        break;
	                                    case "IE":
	                                        postData.profile.sms_notify_ways_to_save = false;
	                                        postData.profile.savings_reminder_email = true;
	                                        postData.profile.ways_to_save_email = false;
	                                        break;
	                                    case "CE":
	                                        postData.profile.sms_notify_ways_to_save = false;
	                                        postData.profile.savings_reminder_email = false;
	                                        postData.profile.ways_to_save_email = true;
	                                        break;
	                                    case "NN":
	                                        postData.profile.sms_notify_ways_to_save = false;
	                                        postData.profile.savings_reminder_email = false;
	                                        postData.profile.ways_to_save_email = false;
	                                        break;
	                                }
	                                services.chc.UserUpdate.saveData(chcData.chcKey, postData).then(lang.hitch(this, function (data2) {
	                                    // TODO: The resolve of saveData isn't doing anything.
	                                    console.log('Data 2 is 456789', data2);
	                                }));
	                            }
	                            this.inputsDisabled = false;
	                            this.headers.alreadyGreen = isPaperless(this);
	                            storeCache(this, "serverCache");


	                            //If save is successful then call retrieve after Save
	                            var serviceAfterRetrieveCalls = [];
				                serviceAfterRetrieveCalls.push($q.when(new Date()));
				                serviceAfterRetrieveCalls.push(services.rbsmbl.memberInfo().fetch());
				                serviceAfterRetrieveCalls.push(services.rbsmbl.AccountSettingsRetrive().retriveAccountSettings(sessionData.groupNumber, "contactPrefView", sessionData.memberInfo.brand, sessionData.memberInfo.userName));

	                            all(serviceAfterRetrieveCalls).then(lang.hitch(this, function (responses) {
	                                //debugger;

	                                this.ums = new UMSParse(responses[1].data.payload, responses[0]);
	                                this.data.mobilePhone = responses[2].data.payload.mobilePhone;

	                                if (btsGlobal.config.brand.sharedBrandCode.toLowerCase() !== 'mincr' && responses[2].data.payload.isCHC) {
	                                    this.model.chcKey = String(this.ums.baseInformation().umi) + String(this.ums.currentMember().pinNumber);
	                                    services.chc.UserShow.getData(this.model.chcKey).then(lang.hitch(this, function (chcData) {
	                                        //this.populateModel(this.model, responses[2].data, chcData.data);

	                                    }), lang.hitch(this, function (error) {
	                                        // couldn't load chc, hide the savings advisor option
	                                        responses[2].data.payload.isCHC = false;
	                                        //this.populateModel(this.model, responses[2].data);
	                                    }));
	                                }
	                                else {
	                                    // this.populateModel(this.model, responses[2].data);
	                                }
	                            }), lang.hitch(this, function (error) {
			                        modal.open(
			                            {
			                                heading: 'Error',
			                                template: '<p>We are having trouble displaying this information right now. You can try to refresh the page or check back in a few minutes.</p><p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'
			                            }
			                        );
	                            }));

	                        }), lang.hitch(this, function (error) {
	                            if (error.response.data.baseMessage.returnCode == 403 || error.response.data.baseMessage.returnCodeDescription == "ERROR_IVR_TEMP_INACTIVE") {
			                        modal.open(
			                            {
			                                heading: 'Text Message System Error',
			                                template: '<p>We are experiencing some technical difficulties and cannot process your request right now. Please try again later.  If the problem continues, please call the number on the back of your member ID card.</p><p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'
			                            }
			                        );
	                            }
	                            else {
			                        modal.open(
			                            {
			                                heading: 'System Error',
			                                template: '<p>We are experiencing some technical difficulties and cannot process your request right now. Please try again later.  If the problem continues, please call the number on the back of your member ID card.</p><p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'
			                            }
			                        );
	                            }
	                            this.inputsDisabled = false;
	                        }));
	                        return saveData;

	                },
	                errorModal: function(error) {
	                    //var content = "<p>" + error.msg + "</p>";
                        modal.open(
                            {
                                heading: error.heading,
                                template: error.msg
                                // templateUrl: 'coverage/medical-benefits.appTemplate.html/chmhom/modals/benefitBookletDisclaimer',
                                // scope: $scope
                            }
                        );
	                },
	                removeSelectOption: function() {
	                    for (var section in this.sections) {
	                        for (var topic in this.sections[section].topics) {
	                            var allowRemove = false;
	                            for (var z = 0; z < this.sections[section].topics[topic].opts.length; z++) {
	                                // allowRemove = allowRemove || (this.sections[section].topics[topic].opts[z].label.toUpperCase() == this.sections[section].topics[topic].selected.value.toUpperCase());
	                                allowRemove = allowRemove || (this.sections[section].topics[topic].opts[z].label.toUpperCase() == this.sections[section].topics[topic].selected.toUpperCase());
	                            }
	                            // allowRemove = allowRemove && this.sections[section].topics[topic].opts[0].label.toUpperCase() === "SELECT" && this.sections[section].topics[topic].selected.value.toUpperCase() != "SELECT";
	                            allowRemove = allowRemove && this.sections[section].topics[topic].opts[0].label.toUpperCase() === "SELECT" && this.sections[section].topics[topic].selected.toUpperCase() != "SELECT";
	                            if (allowRemove) {
	                                this.sections[section].topics[topic].opts.splice(0, 1);
	                            }
	                            else {
	                                this.sections[section].topics[topic].selected = "Select";
	                            }
	                        }
	                    }
	                }
	            },



	            /**
	                Turns a 10 or 11 digit phone number into a 10 digit phone number in the format: (###) ###-####

	                @param {string} phoneNum - The phone number to format
	            */
	            formatPhone: function(phoneNum) {
	                if (phoneNum && phoneNum.length > 0) {
	                    var newNum = phoneNum.match(/[0-9]*/g).join('');
	                    if (newNum.charAt(0) === '1') {
	                        newNum = newNum.substr(1);
	                    }
	                    return '('+newNum.substr(0,3)+') '+newNum.substr(3,3)+'-'+newNum.substr(6,4);
	                }
	            },
	            filterOptions: function(){
	                if(btsGlobal.config.brand.sharedBrandCode.toLowerCase() === 'mincr'){

	                    //Wellness savings more - remove phone number options
	                    var options =  this.model.sections.healthWellness.topics.wellnessSavingsMore.opts;
	                    for (var optionNumber = options.length-1; optionNumber >= 0; optionNumber--) {
	                        if (! (options[optionNumber].label   === 'Select' || options[optionNumber].label   === 'Personal Email' || options[optionNumber].label   === 'U.S. Mail' || options[optionNumber].label ==='Do Not Contact') ) {
	                            this.model.sections.healthWellness.topics.wellnessSavingsMore.opts.splice(optionNumber,1);
	                        }
	                    }

	                    options =  this.model.sections.additionalServices.topics.partnerProducts.opts;
	                    for (optionNumber = options.length-1; optionNumber >= 0; optionNumber--) {
	                        if (! (options[optionNumber].label   === 'Select' || options[optionNumber].label   === 'Personal Email' || options[optionNumber].label   === 'U.S. Mail' || options[optionNumber].label ==='Do Not Contact') ) {
	                            this.model.sections.additionalServices.topics.partnerProducts.opts.splice(optionNumber,1);
	                        }
	                    }
	                }
	            },
	            populateModel: function(model, data, chcData){
	                var that = this;
	                model.currentPortalPlan = this.ums.getPortalSelectedPlan();
	                model.benefitPlanName = model.currentPortalPlan[0].benefitPlanName;
	                model.displayGroupNumber = model.currentPortalPlan[0].displayGroupNumber;

	                var groupCount = 0;
	                this.ums.setFilterState('current');
	                var mi = this.ums.ASMemberInfoFeed();
	                if (mi && mi.clientList) {
	                    for (var g = 0; g < mi.clientList.length; g++) {
	                        groupCount = groupCount + (mi.clientList[g].groupList && mi.clientList[g].groupList.length || 0);
	                    }
	                }
	                model.isIBC = (btsGlobal.config.brand.sharedBrandCode.toLowerCase() === 'ibccr' || btsGlobal.config.brand.sharedBrandCode.toLowerCase() === 'ibcah');
	                if (groupCount > 1 && !model.isIBC) {
	                    model.showVSBP = true;
	                }

	                model.sections = {
	                    "alertsNotifications": {
	                        "title": (btsGlobal.config.brand.sharedBrandCode.toLowerCase() === 'mincr')?"Health Plan" :"Alerts & Notifications",// Health Administration
	                        "topics": {
	                            "invoices": {
	                                "opts": [
	                                    {label: "Select", value: "Select"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "U.S. Mail", value: "U.S. Mail"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_INVOICES || "{\n\t\"label\": \"Invoices\",\n\t\"value\": \"<p>Notice when your</p> <p>invoice is ready to be paid.</p>\",\n\t\"altText\": \"Notice when your invoice is ready to be paid.\",\n\t\"serviceName\": \"selectedInvioces\"\n}"),
	                                "specialContent": "",
	                                "selected": {}
	                            },
	                            "eob": {
	                                "opts": [
	                                    {label: "Select", value: "Select"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "U.S. Mail", value: "U.S. Mail"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_EOBC || "{\n\t\t\t\t\t\t\t\t\"label\": \"Explanation of Benefits & Claims\", \n\t\t\t\t\t\t\t\t\"value\":\"<p>Notice of paid, </p><p>denied, or delayed claims.</p>\",\n                                \"altText\":\"Notice of paid, denied, or delayed claims.\",\n                                \"serviceName\": \"selectedEOB\"\n\t\t\t\t\t\t\t}"),
	                                "specialContent": "",
	                                "selected": {}
	                            },
	                            "insurancePlanNotices": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "U.S. Mail", value: "U.S. Mail"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_IPN || "{\n\t\"label\": \"Insurance Plan Notices\",\n\t\"value\": \"<p>Including Coverage Agreement,</p><p>Outline of Coverage, Endorsements,</p><p>Amendatory Riders, Benefit Changes,</p><p>Legal Notices, Benefit Booklet,</p><p>Summary of Benefits and Coverage,</p><p> Provider Information and other important reminders.</p>\",\n\t\"altText\": \"Information about benefit changes, legal notices, provider information, and other important reminders.\",\n\t\"serviceName\": \"selectedAlertNotification\"}"),
	                                "specialContent": "",
	                                "selected": {}
	                            },
	                            "healthStatements": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Text Message", value: "Text Message"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "Do Not Contact", value: "Do Not Contact"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_HS || "{\n\t\"label\": \"Health Statement\",\n\t\"value\": \"<p>Notice when your Health</p> <p>Statement is ready </p><p>for your review.</p>\",\n\t\"altText\": \"Notice when your Health Statement is ready for your review.\",\n\t\"serviceName\": \"selectedHealthStatements\"\n}"),
	                                "specialContent": "",
	                                "selected": {}
	                            }
	                        }
	                    },

	                    "healthWellness": {
	                        "title": "Health & Wellness",
	                        "topics": {
	                            "wellnessSavingsMore": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "U.S. Mail", value: "U.S. Mail"},
	                                    {label: "Home Phone", value: "Home Phone"},
	                                    {label: "Mobile Phone", value: "Mobile Phone"},
	                                    {label: "Work Phone", value: "Work Phone"},
	                                    {label: "Do Not Contact", value: "Do Not Contact"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_HW || "{\n\t\"label\": \"Wellness, Savings & More\",\n\t\"value\": \"Health & wellness benefits, programs, and services available as part of your plan.\",\n\t\"serviceName\": \"selectedWellness\"\n}"),
	                                "specialContent": "",
	                                "selected": {}
	                            },
	                            "memberNewsletter": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "U.S. Mail", value: "U.S. Mail"},
	                                    {label: "Do Not Contact", value: "Do Not Contact"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_MN || "{\n\t\"label\": \"Member Newsletter\",\n\t\"value\": \"Newsletters that discuss member benefits, programs, and discounts.\",\n\t\"serviceName\": \"selectedNewsletters\"\n}"),
	                                "specialContent": "",
	                                "selected": {}
	                            },
	                            "healthCoach": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Home Phone", value: "Home Phone"},
	                                    {label: "Mobile Phone", value: "Mobile Phone"},
	                                    {label: "Work Phone", value: "Work Phone"},
	                                    {label: "Do Not Contact", value: "Do Not Contact"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_HC || "{\n\t\"label\": \"Health Coach\",\n\t\"value\": \"Talk with a professional to help you better manage your health.\",\n\t\"serviceName\": \"selectedHealthNurseOutreach\"\n}"),
	                                "specialContent": "* Health Coaches are available by phone only. Select a phone option for Health Coach.",
	                                "selected": {}
	                            },
	                            "passportReminder": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "Home Phone", value: "Home Phone"},
	                                    {label: "Mobile Phone", value: "Mobile Phone"},
	                                    {label: "Work Phone", value: "Work Phone"},
	                                    {label: "U.S. Mail", value: "U.S. Mail"},
	                                    {label: "Do Not Contact", value: "Do Not Contact"}
	                                ],
	                                "text": JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_PASSPORT || "{\n\t\"label\": \"Passport Rewards\",\n\t\"value\": \"Earn rewards for taking healthy steps designed just for you.\",\n\t\"serviceName\": \"programReminderValue\"\n}"),
	                                "specialContent": "",
	                                "selected": {}
	                            }
	                        }
	                    },
	                    "additionalServices": {
	                        "title": "Additional Services",
	                        "topics": {
	                            "savingsAdvisor": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Work Email", value: "Work Email"},
	                                    {label: "Do Not Contact", value: "Do Not Contact"}
	                                ],
	                                text: JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_SAA || "{\n\t\"label\": \"Savings Advisor Alerts\",\n\t\"value\": \"Notices about possible cost savings on prescriptions, providers, and services.\",\n\t\"serviceName\": \"selectedSavingsAdvisor\"\n}"),
	                                "specialContent": "* To get Savings Advisor Alerts by email, you will need to enter your personal email address first.",
	                                "selected": {}
	                            },
	                            "partnerProducts": {
	                                "opts":[
	                                    {label: "Select", value: "Select"},
	                                    {label: "Personal Email", value: "Personal Email"},
	                                    {label: "U.S. Mail", value: "U.S. Mail"},
	                                    {label: "Home Phone", value: "Home Phone"},
	                                    {label: "Mobile Phone", value: "Mobile Phone"},
	                                    {label: "Work Phone", value: "Work Phone"},
	                                    {label: "Do Not Contact", value: "Do Not Contact"}
	                                ],
	                                text: JSON.parse(model.teamsiteContent.MER_CNTCTPREF_TT_OPS || "{\n\t\"label\": \"Other Products & Services\",\n\t\"value\": \"Vendor discounts, programs, classes, and insurance coverage that is not a part of your plan.\",\n\t\"serviceName\": \"selectedOtherProdServ\"\n}"),
	                                "specialContent": "",
	                                "selected": {}
	                            }
	                        }
	                    }
	                };

	                this.model.toolTipSecure = '<div style="width:260px;"><p>Receive Health Wire text messages (Maximum of 2 per month) that link you to information about how to manage your health care and save money.</p> <p> After enrolling, you’ll receive a text message to verify your phone number. You can text the word “stop” to opt out of this service at any time. </p></div>';
	                this.model.toolTipSecureAlt = 'Receive Health Wire text messages (up to 2 per month) linking you to information about easy ways to manage your healthcare, improve your health and save money. After enrolling, you will receive a text message verification at the number you provided. You can opt out of this service at any time.';

	                this.model.toolTipEmail = '<p style="width:200px;">Set your contact preferences to personal email where applicable</p>';
	                this.model.toolTipEmailAlt = 'Set your contact preferences to personal email where applicable.';

	                //Unused right now - will possibly be used for a future release.
	                //this.filterOptions();
	                model.headers = {
	                    "title": "Contact Preferences",
	                    "green": "Go Paperless",
	                    "paperlessEmail": "Yes, email me",
	                    "secureText": "Yes, text me",
	                    "greenTagline": "Opt-in to receive alerts, benefits information, preventative care reminders and more. Paperless communication is faster and more convenient.",
	                    "greenAlert": false,
	                    "checked":{label: "checked", value: false},
	                    "checkedSDC":{label: "checked", value: false},
	                    "sdcMobilePhone":{value:''},
	                    "alreadyGreen": false
	                };
	                model.noPrefsText = "Your contact preferences have been set by the type of coverage you have. Have questions or concerns about how we will contact you? Please call the number on the back of your member ID card.";
	                model.isHCR = data.payload.isHCR;
	                model.isOnExchange = (data.payload.hcrProduct && data.payload.hcrProduct.toLowerCase() === 'on') ? true : false;
	                model.isDirectPay = data.payload.isDirectPay;
	                model.isDependent = (data.payload.getRelationshipCode && data.payload.getRelationshipCode.toLowerCase() != 'subscriber') ? true : false;
	                model.isDirectPayMedicare = data.payload.isDirectPayMedicare;
	                model.isGroupMedicare = data.payload.isGroupMedicare;
	                model.isCHC = data.payload.isCHC; // Means savings advisor also
	                model.cache = {
	                    serverCache: {},
	                    paperlessCache: {},
	                    prefsCache: {}
	                };

	                // Moved "contactPreferenceHelper" so the logic can live in one place and be used across multiple pages.
	                //model.isBlueEdgeDentalIndv = contactPreferenceHelper.isBlueEdgeDentalIndv(model.currentPortalPlan);

	                model.chcData = chcData;
	                if (model.chcData) {
	                    model.chcData.chcKey = model.chcKey;
	                    // Add personal email as a savings advisor option if personal email is confirmed
	                    if (data.payload.emailConfirmedInd && data.payload.emailConfirmedInd.toLowerCase() === 'confirmed') {
	                        model.sections.additionalServices.topics.savingsAdvisor.opts.splice(1,0, {label: "Personal Email", value: "Personal Email"});
	                    }
	                    // Add text message as a savings advisor option if mobile number is present and verified
	                    if (model.chcData.user && model.chcData.user.mobile_phone && model.chcData.user.mobile_phone.mobile_phone_state == 'verified') {
	                        if (data.payload.mobilePhone == model.chcData.user.mobile_phone.phone_number) {
	                            // Only show text message option if the mobile # is verified, and the same on chm as it is on chc
	                            model.sections.additionalServices.topics.savingsAdvisor.opts.splice(1,0, {label: "Text Message", value: "Text Message"});
	                        }
	                    }
	                }
	                model.data = data.payload;

	                model.hasWorkEmail = model.data.workEmailAddress ? true : false;
	                model.hasWorkEmail = model.isCHC ? model.isCHC : model.hasWorkEmail;

	                // Secure Digital Checks
	                model.isSDCEligiblity = data.payload.secureTextMessageEligibility;
	                model.hasMobileNumber = ((data.payload.mobilePhone || '') != '');
	                model.bIsMobileNoVisible = false ;
	                model.isOptIn = data.payload.secureTextMessageOptInOut;
	                model.headers.checkedSDC = {value: model.isOptIn } ;

	                var selectedPlan = this.ums.getPortalSelectedPlan()[0],
	                    currentMember = lang.clone(that.ums.currentMember()),
	                    clientList = lang.clone(that.ums.clients()),
	                    currentClient;
	                clientList.some(function(val,ind){
	                    if (val.clientNumber == currentMember.clientNumber){
	                        currentClient = lang.clone(val);
	                        return true;
	                    }
	                });
	                var mncoverageBeginDate = (selectedPlan.productList[0].coverageBeginDate != "") ? selectedPlan.productList[0].coverageBeginDate : selectedPlan.productList[0].coverageConBeginDate;
	             model.fullData = {
	                    groupNumber: btsGlobal.config.portalGroupNumber,
	                    address1: model.data.address1,
	                    address2: model.data.address2,
	                    address3: model.data.address3,
	                    address4: model.data.address4,
	                    city: model.data.city,
	                    state: model.data.state,
	                    zip: model.data.zip,
	                    mobilePhone: model.data.mobilePhone,
	                    secureTextMessageOptInOut:'',
	                    intakeRequest: {
	                        "bdUserId": "B"+ that.ums.baseInformation().bvUserId,
	                        "contactFirstName": currentMember.firstName,
	                        "contactMiddleName": currentMember.middleName,
	                        "contactLastName": currentMember.lastName,
	                        "memberFirstName": currentMember.firstName,
	                        "memberMiddleName": currentMember.middleName,
	                        "memberLastName": currentMember.lastName,
	                        "birthDate": currentMember.dob,
	                        "gender": currentMember.gender,
	                        "relationshipCode": currentMember.relationshipCode,
	                        "enrollmentSourceCode": currentClient.enrollmentSourceCode,
	                        "ecId": currentMember.ecId,
	                        "umi": that.ums.baseInformation().umi,
	                        "lob": selectedPlan.productList[0].lob,
	                        "alphaPrefix": selectedPlan.productList[0].alphaPrefix,
	                        "groupNumber": currentMember.groupNumber,
	                        "benefitPlanName": selectedPlan.productList[0].benefitPlanName,
	                        "coverageBeginDate": mncoverageBeginDate,
	                        "coverageEndDate": selectedPlan.productList[0].coverageEndDate,
	                        "agreementId": that.ums.baseInformation().agreementId,
	                        "clientName": currentClient.clientName,
	                        "clientId": currentClient.clientId,
	                        "coveredIndividualId": currentMember.ciid,
	                        "internalGroupNumber": selectedPlan.internalGroupNumber
	                    }
	                }
	                // model.saveArticle = new Article({
	                //     name: 'account/save-fpo',
	                //     model: {
	                //         parentArticle: that,
	                //         marketingAuthorizationAccepted: model.data.marketingAuthorizationAccepted
	                //     }
	                // }, 'save-fpo');

	                // Rules for which contact preferences to display for the current member have been moved to the
	                // "contactPreferenceHelper" so the logic can live in one place and also be used on other pages.
	                var preferences = this.getMemberContactPreferences(this.ums, model.data);
	                if(btsGlobal.config.brand.sharedBrandCode.toLowerCase() === 'wybcbs') {
	                    var firstLoad = true;
	                    for (var commPref in preferences) {
	                        if (preferences[commPref] &&
	                            preferences[commPref].selected &&
	                            preferences[commPref].section &&
	                            model.sections[preferences[commPref].section] &&
	                            model.sections[preferences[commPref].section].topics[commPref] &&
	                            model.sections[preferences[commPref].section].topics[commPref].selected && preferences[commPref].selected.originalValue && preferences[commPref].selected.originalValue != '') {
	                            firstLoad = false;
	                        }
	                    }
	                }
	                for (var commPref in preferences) {
	                    if (preferences[commPref] &&
	                            preferences[commPref].selected &&
	                            preferences[commPref].section &&
	                            model.sections[preferences[commPref].section] &&
	                            model.sections[preferences[commPref].section].topics[commPref] &&
	                            model.sections[preferences[commPref].section].topics[commPref].selected) {

	                        model.sections[preferences[commPref].section].topics[commPref].canView = preferences[commPref].canView;
	                        // model.sections[preferences[commPref].section].topics[commPref].selected.value = translate(model, preferences[commPref].selected.originalValue);
	                        model.sections[preferences[commPref].section].topics[commPref].selected = translate(model, preferences[commPref].selected.originalValue);
	                    }
	                }

	                for (var section in model.sections) {
	                    var rowColor = 0;
	                    for (var topic in model.sections[section].topics) {
	                        if (model.sections[section].topics[topic].canView) {
	                            //if this topic is set to be viewable by current user
	                            if (topic !== "healthCoach" && (topic !== "savingsAdvisor" || (model.data.emailConfirmedInd && model.data.emailConfirmedInd.toLowerCase() === 'confirmed'))) {
	                                model.headers.canViewGreen = true;
	                            }
	                            model.hasPrefs = true;
	                            model.sections[section].canView = true;
	                            model.sections[section].topics[topic].rowColor = (rowColor++ % 2);
	                        }
	                    }
	                }
	                if(btsGlobal.config.brand.sharedBrandCode.toLowerCase() === 'wybcbs') {
	                    model.setPaperlessBox(firstLoad);
	                }else{
	                    model.setPaperlessBox();
	                }
	                model.headers.alreadyGreen = isPaperless(model);


	                model.removeSelectOption();
	                storeCache(model, "serverCache");
	                storeCache(model, "prefsCache");
					model.showHideThirdPartyAuth();
	            },
	            /**
	                Fetches the contact information data, and populates the model.
	            */
		        isBlueEdgeDentalIndv: function(currentPortalPlan) {
		            var isBlueEdgeDentalIndv = false;
		            if (currentPortalPlan && currentPortalPlan[0] && currentPortalPlan[0].productList) {
		                var blueEdgeDentalCount = 0;
		                for (var i = 0; i < currentPortalPlan[0].productList.length; i++) {
		                    if (currentPortalPlan[0].productList[i].blueEdgeDentalIndv === 'true') {
		                        blueEdgeDentalCount++;
		                    }
		                }
		                // If all products are blue edge dental
		                if (blueEdgeDentalCount === currentPortalPlan[0].productList.length) {
		                    isBlueEdgeDentalIndv = true;
		                }
		            }
		            return isBlueEdgeDentalIndv;
		        },

		        getMemberContactPreferences: function(ums, data) {
		            var currentMember = ums.currentMember();
		            var brand = btsGlobal.config.brand.sharedBrandCode.toLowerCase();
		            var currentPortalPlan = ums.getPortalSelectedPlan();
		            var isBlueEdgeDentalIndv = this.isBlueEdgeDentalIndv(currentPortalPlan);
		            var preferences = {
		                invoices: { canView: false, section: "alertsNotifications", selected: {originalValue: data.selectedInvioces }},
		                eob: { canView: false, section: "alertsNotifications", selected: {originalValue: data.selectedEOB }},
		                insurancePlanNotices: { canView: false, section: "alertsNotifications", selected: {originalValue: data.selectedAlertNotification }},
		                healthStatements: { canView: false, section: "alertsNotifications", selected: {originalValue: data.selectedHealthStatements }},
		                wellnessSavingsMore: { canView: false, section: "healthWellness", selected: {originalValue: data.selectedWellness }},
		                memberNewsletter: { canView: false, section: "healthWellness", selected: {originalValue: data.selectedNewsletters }},
		                healthCoach: { canView: false, section: "healthWellness", selected: {originalValue: data.selectedHealthNurseOutreach }},
		                passportReminder: { canView: false, section: "healthWellness", selected: {originalValue: data.programReminderValue }},
		                savingsAdvisor: { canView: false, section: "additionalServices", selected: {originalValue: data.selectedSavingsAdvisor }},
		                partnerProducts: { canView: false, section: "additionalServices", selected: {originalValue: data.selectedOtherProdServ }}
		            };

		            //invoices
		            if (data.getRelationshipCode.toUpperCase() == 'SUBSCRIBER' && data.eBillInd == 'Y' && (data.medicalCoverage || data.hmBrandedDentalInd)) {
		                preferences.invoices.canView = true;
		            }
		            //eob
		            if (data.getRelationshipCode.toUpperCase() == 'SUBSCRIBER' && (data.hmBrandedDentalInd || data.medicalCoverage)) {
		                preferences.eob.canView = true;
		            }
		            // Allow EOB for Minnesota Subscriber and any dependent age 12 and over.
		            if (brand === 'mincr') {
		                var age = date.getAge(currentMember.dob);
		                if ((data.getRelationshipCode.toUpperCase() === 'SUBSCRIBER' || age >= 12) && (data.hmBrandedDentalInd || data.medicalCoverage)) {
		                    preferences.eob.canView = true;
		                } else {
		                    preferences.eob.canView = false;
		                }
		            }
		            //planNotice
		            if (data.medicalCoverage) {
		                preferences.insurancePlanNotices.canView = true;
		            }
		            //healthStmt
		            if (data.getRelationshipCode.toUpperCase() == 'SUBSCRIBER' && data.lobCode.toUpperCase() != 'AG' && data.lobCode.toUpperCase() != 'NC' &&
		                    !(data.visionCoverage == true && data.medicalCoverage == false && data.dentalCoverage == false && data.DrugCoverage == false)) {
		                preferences.healthStatements.canView = true;
		            }
		            //Do not show for Minnesota
		            if (brand === 'mincr' || brand === 'ndbcbs') {
		                preferences.healthStatements.canView = false;
		            }
		            //wellness
		            if (data.medicalCoverage && data.lobCode != 'AG' && !isBlueEdgeDentalIndv) {
		                preferences.wellnessSavingsMore.canView = true;
		            }
		            //newsletter
		            if (data.getRelationshipCode.toUpperCase() == 'SUBSCRIBER' && data.medicalCoverage && !data.isOptOut && !isBlueEdgeDentalIndv) {
		                preferences.memberNewsletter.canView = true;
		            }
		            //Do not show for Minnesota
		            if (brand === 'mincr') {
		                preferences.memberNewsletter.canView = false;
		            }
		            //healthCoach
		            if (data.medicalCoverage || data.lobCode.toUpperCase() == 'AG' ||(data.dentalCoverage && data.visionCoverage) || (data.dentalCoverage && data.DrugCoverage) || (data.visionCoverage && data.DrugCoverage) && !isBlueEdgeDentalIndv) {
		                //users with blues on call can view
		                //users with medical coverage can view
		                //members with at least 2 of the single coverages (vision, dental, drug) can view
		                preferences.healthCoach.canView = true;
		            }
		            if (brand === 'ndbcbs') {
		                preferences.healthCoach.canView = false;
		            }
		            //savingsAlerts
		            if (brand !=='mincr' && data.isCHC) {
		                preferences.savingsAdvisor.canView = true;
		            }
		            //partnerProds
		            if (data.medicalCoverage || data.hmBrandedDentalInd && data.selectedOtherProdServ != "Do Not Contact") {
		                preferences.partnerProducts.canView = true;
		            }

		            // passport preferences
		            var passportReminderPlans=["SECURITYBLUE HMO", "SECURITY BLUE HMO", "FREEDOMBLUE PPO", "FREEDOM BLUE PPO", "COMMUNITY BLUE MEDICARE HMO"];
		            if(brand !== 'mincr' && ums.getPortalSelectedPlan().length>0 && ums.getPortalSelectedPlan()[0].benefitPlanName && passportReminderPlans.indexOf(ums.getPortalSelectedPlan()[0].benefitPlanName.toUpperCase())>0){
		                preferences.passportReminder.canView = true;
		            }
		            return preferences;
		        },
                getTeamsiteContent: function() {
                    return aemContent.getAEMJsonContent().then(function(data) {
                        return {
							'MER_CNTCTPREF_TITLE': aemContent.getContentValue(data['MER_CNTCTPREF_TITLE']),
							'MER_CNTCTPREF_DIFF_OPT': aemContent.getContentValue(data['MER_CNTCTPREF_DIFF_OPT']),
							'MER_CNTCTPREF_OPT_NOT_AVAIL': aemContent.getContentValue(data['MER_CNTCTPREF_OPT_NOT_AVAIL']),
							'MER_CNTCTPREF_STD_RATES': aemContent.getContentValue(data['MER_CNTCTPREF_STD_RATES']), 
							'MER_CNTCTPREF_COMM_ERR': aemContent.getContentValue(data['MER_CNTCTPREF_COMM_ERR']),
							'MER_CNTCTPREF_TT_EOBC': aemContent.getContentValue(data['MER_CNTCTPREF_TT_EOBC']),
							'MER_CNTCTPREF_TT_IPN': aemContent.getContentValue(data['MER_CNTCTPREF_TT_IPN']),
							'MER_CNTCTPREF_TT_HS': aemContent.getContentValue(data['MER_CNTCTPREF_TT_HS']),
							'MER_CNTCTPREF_TT_HW': aemContent.getContentValue(data['MER_CNTCTPREF_TT_HW']),
							'MER_CNTCTPREF_TT_MN': aemContent.getContentValue(data['MER_CNTCTPREF_TT_MN']),
							'MER_CNTCTPREF_TT_HC': aemContent.getContentValue(data['MER_CNTCTPREF_TT_HC']),
							'MER_CNTCTPREF_TT_OPS': aemContent.getContentValue(data['MER_CNTCTPREF_TT_OPS']),
							'MER_CNTCTPREF_TT_INVOICES': aemContent.getContentValue(data['MER_CNTCTPREF_TT_INVOICES']),
							'MER_CNTCTPREF_TT_PASSPORT': aemContent.getContentValue(data['MER_CNTCTPREF_TT_PASSPORT']),
							'MER_CNTCTPREF_TT_SAA': aemContent.getContentValue(data['MER_CNTCTPREF_TT_SAA'])
                        };
                    });
                },
	            preRender: function(deferred) {
	                var self = this;
	                var serviceCalls = [];

	                serviceCalls.push($q.when(new Date()));
	                serviceCalls.push(services.rbsmbl.memberInfo().fetch());
	                serviceCalls.push(services.rbsmbl.AccountSettingsRetrive().retriveAccountSettings(sessionData.groupNumber, "contactPrefView", sessionData.memberInfo.brand, sessionData.memberInfo.userName));
	                if (this.getTeamsiteContent) {
	                    serviceCalls.push(this.getTeamsiteContent());
	                }

	                all(serviceCalls).then(lang.hitch(this, function (responses) {
	                    if (responses[3]) {
	                        // Teamsite data
	                        this.model.teamsiteContent = responses[3];
	                    }

	                    this.ums = new UMSParse(responses[1].data.payload, responses[0]);
	                    if (btsGlobal.config.brand.sharedBrandCode.toLowerCase()!=='mincr'  &&  responses[2].data.payload.isCHC) {
	                        this.model.chcKey = String(this.ums.baseInformation().umi) + String(this.ums.currentMember().pinNumber);
	                        services.chc.UserShow.getData(this.model.chcKey).then(lang.hitch(this, function(chcData) {
	                            this.populateModel(this.model, responses[2].data, chcData.data);
	                            // deferred.resolve();

	                        }), lang.hitch(this, function(error) {
	                            // couldn't load chc, hide the savings advisor option
	                            responses[2].data.payload.isCHC = false;
	                            this.populateModel(this.model, responses[2].data);
	                            // deferred.resolve();
	                        }));
	                    }
	                    else {
	                        this.populateModel(this.model, responses[2].data);

	                        // deferred.resolve();
	                    }
	                }), lang.hitch(this, function(error) {
	                    new Modal('<p>We are having trouble displaying this information right now. You can try to refresh the page or check back in a few minutes.</p><p class="text-r"><button data-click="closeModal()" class="action-btn">OK</button></p>', {heading: 'Error'});
	                }));
	            },
	            // Expose functions defined earlier, so that they can be unit tested
	            translate: translate,
	            reverseTranslate: reverseTranslate,
	            isPaperless: isPaperless,
	            errorCheck: errorCheck,
	            storeCache: storeCache,
	            restoreCache: restoreCache,
	            changesExist: changesExist

            }



			function dojoConvert() { 
                return toMerge;
            };
            var d = new dojoConvert();
            angular.extend($scope, d.model);
            d.model = $scope;
            d.preRender();


            $scope.heading = "Contact Preferences";
        }
    ]);
}